import { VStack } from '@chakra-ui/react';
import { useNavigate, useParams } from 'react-router-dom';
import MealItemCard from '~/components/MealItemCard';
import { PLATFORM_ID } from '~/globalVariables';

import { ItemWithId } from '~/types/store/item';

type PopularMealProps = {
  items: Array<
    Pick<ItemWithId, 'name' | 'image' | 'price' | 'description' | 'tags'> & {
      storeId: string;
      id?: string;
      itemId?: string;
      disabled?: boolean;
    }
  >;
};

export default function PopularMeal({ items }: PopularMealProps) {
  const navigate = useNavigate();
  const { groupId = '' } = useParams();

  return (
    <VStack align="stretch" py={2} spacing={1}>
      {items.map((item) => {
        return (
          <MealItemCard
            key={item.id || item.itemId}
            name={item.name}
            image={item.image}
            price={item.price}
            description={item.description}
            disabled={item.disabled}
            tags={item.tags[PLATFORM_ID] || []}
            onNavigate={() =>
              navigate(
                groupId
                  ? `/group/${groupId}/store/${item.storeId}/item/${item.id || item.itemId}/add`
                  : `/store/${item.storeId}/item/${item.id || item.itemId}/add`,
                { state: { previous: window.location.pathname } },
              )
            }
          />
        );
      })}
    </VStack>
  );
}
